import { tap, getOr, get } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import { addDesignToJob } from '../api/mandi';
import estimateLoaded from './estimateLoaded';
import estimateCopied from './estimateCopied';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import addEstimateToShareStoreSelection from './share/addEstimateToSelection';
import removeEstimateFromShareSelection from './share/removeEstimateFromSelection';
import saveToMyAccount from './saveToMyAccount';
import { createAndSendButtonSubmissionEventWithEventName } from '../analytics/commonAnalytics';
import AnalyticsConstants from '../analytics/constants';

const copyEstimate = newName => (dispatch, getState) => {
  dispatch(loading());
  const { uiState, entities } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;
  const { estimates } = entities;
  const originalEstimateContainers = estimates.byId[selectedEstimate].containers;

  return designBuilderApi
    .copyDesign(selectedEstimate, newName)
    .then(async (response) => {
      createAndSendButtonSubmissionEventWithEventName(
        window.globalConfig.siteId,
        AnalyticsConstants.EventNames.DesignDuplicate,
      );

      const containerMap = {};
      const design = dispatch(estimateLoaded(response.data));


      for (let idx = 0; idx < originalEstimateContainers.length; idx += 1) {
        containerMap[originalEstimateContainers[idx]] = design.containers[idx];
      }

      dispatch(estimateCopied(selectedEstimate, design.designId, containerMap));
      dispatch(saveToMyAccount(design.designId));
      dispatch(removeEstimateFromShareSelection(selectedEstimate));
      dispatch(addEstimateToShareStoreSelection(design.designId));

      if (getOr(false, 'attributes.isMandi', design)) {
        await addDesignToJob(get('attributes.jobUid', design), get('designId', design));
      }

      return design;
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};

export default copyEstimate;
